var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnicality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.667 3.33331H15.8337V10.8333L13.3337 8.95831L10.8337 10.8333V3.33331H6.66699V13.3333H16.667V3.33331Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 18.3334H15.0003V16.6667H3.33366V5.00002H1.66699V16.6667C1.66699 17.5834 2.41699 18.3334 3.33366 18.3334ZM18.3337 13.3334V3.33335C18.3337 2.41669 17.5837 1.66669 16.667 1.66669H6.66699C5.75033 1.66669 5.00033 2.41669 5.00033 3.33335V13.3334C5.00033 14.25 5.75033 15 6.66699 15H16.667C17.5837 15 18.3337 14.25 18.3337 13.3334ZM12.5003 3.33335H14.167V7.50002L13.3337 6.87502L12.5003 7.50002V3.33335ZM6.66699 3.33335H10.8337V10.8334L13.3337 8.95835L15.8337 10.8334V3.33335H16.667V13.3334H6.66699V3.33335Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicality);
export default __webpack_public_path__ + "static/media/technicality.3041b886e4beb8e7b055ea7eb35fdd0e.svg";
export { ForwardRef as ReactComponent };